// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: "Unilever Desire", sans-serif, -apple-system,
    BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell",
    "Fira Sans", "Droid Sans", "Helvetica Neue" !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: "Unilever Desire", source-code-pro, Menlo, Monaco, Consolas,
    "Courier New", monospace;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

.ReactModal__Overlay{
  background-color: rgba(0, 0, 0, 0.5) !important;
}

/* Floating label animations and positioning */
.form-floating > label {
  transition: transform 0.2s ease, padding 0.2s ease, height 0.2s ease, opacity 0.2s ease;
}

.form-floating > .form-control:not(:focus):placeholder-shown ~ label,
.form-floating > .form-control-plaintext:not(:focus):placeholder-shown ~ label {
  top: 0;
  height: 100%;
  margin: 0;
  padding: 0 16px;
  display: flex;
  align-items: center;
  transform: none;
}

.form-floating > .form-control:focus ~ label,
.form-floating > .form-control:not(:placeholder-shown) ~ label,
.form-floating > .form-control-plaintext ~ label {
  height: calc(3.5rem + calc(var(--bs-border-width) * 2));
  padding: 1rem 0.75rem;
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}

`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;;0DAEwD;EACxD,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE;4BAC0B;AAC5B;;AAEA;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA,YAAY;AACZ;EACE,0BAA0B;AAC5B;;AAEA;EACE,+CAA+C;AACjD;;AAEA,8CAA8C;AAC9C;EACE,uFAAuF;AACzF;;AAEA;;EAEE,MAAM;EACN,YAAY;EACZ,SAAS;EACT,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;;;EAGE,uDAAuD;EACvD,qBAAqB;EACrB,8DAA8D;AAChE","sourcesContent":["body {\n  margin: 0;\n  font-family: \"Unilever Desire\", sans-serif, -apple-system,\n    BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Cantarell\",\n    \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\" !important;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: \"Unilever Desire\", source-code-pro, Menlo, Monaco, Consolas,\n    \"Courier New\", monospace;\n}\n\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Firefox */\ninput[type=number] {\n  -moz-appearance: textfield;\n}\n\n.ReactModal__Overlay{\n  background-color: rgba(0, 0, 0, 0.5) !important;\n}\n\n/* Floating label animations and positioning */\n.form-floating > label {\n  transition: transform 0.2s ease, padding 0.2s ease, height 0.2s ease, opacity 0.2s ease;\n}\n\n.form-floating > .form-control:not(:focus):placeholder-shown ~ label,\n.form-floating > .form-control-plaintext:not(:focus):placeholder-shown ~ label {\n  top: 0;\n  height: 100%;\n  margin: 0;\n  padding: 0 16px;\n  display: flex;\n  align-items: center;\n  transform: none;\n}\n\n.form-floating > .form-control:focus ~ label,\n.form-floating > .form-control:not(:placeholder-shown) ~ label,\n.form-floating > .form-control-plaintext ~ label {\n  height: calc(3.5rem + calc(var(--bs-border-width) * 2));\n  padding: 1rem 0.75rem;\n  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
